/** @format */

import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next/hooks';
import { useStoreState, useStoreActions } from 'easy-peasy';

function LegPicker() {
	const [t] = useTranslation('translation');

	const service = useStoreActions((actions) => actions.travelSearch);
	const data = useStoreState((state) => state.travelSearch);

	useEffect(() => {
		service.setStopIdsToIgnore(process.env.REACT_APP_STOPIDSTOIGNORE);
		service.fetchAvailableFromStops();
		// eslint-disable-next-line
	}, []);

	return (
		<>
			<div className='with-label' key='21'>
				<label>{t('travelFrom')}</label>
				<select
					className={data.availableFromStops.length < 1 ? 'loading' : ''}
					value={data.fromStop !== null && data.fromStop.id}
					onChange={(e) => {
						service.setFromStop(e.target);
						service.fetchAvailableToStops(e.target.value);
					}}
				>
					<option key='0'>{data.availableFromStops.length < 1 ? t('loadingDepartures') : t('selectDeparture')}</option>
					{data.availableFromStops.map((r, index) => (
						<option value={r.id} key={r.id}>
							{r.name}
						</option>
					))}
				</select>
			</div>
			<div className='with-label' key='22'>
				<label>{t('travelTo')}</label>
				<select
					className={data.availableToStopsLoading === true ? 'loading' : ''}
					value={data.toStop !== null && data.toStop.id}
					onChange={(e) => service.setToStop(e.target)}
				>
					<option key='0'>
						{data.fromStop !== null && data.availableToStops.length < 1
							? t('loadingDestinations')
							: t('selectDestination')}
					</option>
					{data.availableToStops.map((r, index) => (
						<option value={r.id} key={r.id}>
							{r.name}
						</option>
					))}
				</select>
			</div>
		</>
	);
}

export default LegPicker;
